import * as React from "react";
import { useState, useEffect } from "react";
import PageContainer from "../core/PageContainer";
import Breadcrumbs from "../core/Breadcrumbs";
import ModernCard from "../core/ModernCard";
import Button from "../core/Button";
import { jfetch } from "../../utils";
import Loader from "../core/Loader";
import { setUser } from "@sentry/browser";

function OrganizationIndex() {
  const breadcrumbs = [{ label: "Organizations" }];
  return (
    <PageContainer>
      <Breadcrumbs crumbs={breadcrumbs} />
      <ModernCard title={"Organizations & Users"} ta="left" p="24px 34px" m="0px 0px 30px 0px">
        <div className="row text-right">
          <div className="col-lg-12">
            <Button color="primary" href="/organizations/new">
              <i className="fa fa-plus" /> New Org
            </Button>
          </div>
        </div>
        <div className="row" style={{paddingTop:'8px'}}>
          <div className="col-lg-12">
            <ul className="nav nav-tabs" role="tablist">
              <li role="presentation" className="active">
                <a href="#orgs" aria-controls="orgs" role="tab" data-toggle="tab">Organizations</a>
              </li>
              <li role="presentation">
                <a href="#users" aria-controls="users" role="tab" data-toggle="tab">Users</a>
              </li>
            </ul>
            <div className="tab-content">
              <div role="tabpanel" className="tab-pane fade in active" id="orgs" style={{paddingTop:'15px'}}>
                <OrgsTable/>                
              </div>
              <div role="tabpanel" className="tab-pane fade" id="users" style={{paddingTop:'15px'}}>
               <UsersTable/>
              </div>
            </div>
          </div>
        </div>
      </ModernCard>
    </PageContainer>
  );
}

interface OProps{
}

function OrgsTable(props:OProps){
  const [orgs, setOrgs] = useState([])
  const [resultsCount, setResultsCount] = useState(0)
  const [pageCount, setPageCount] = useState(0)
  const [curPage, setCurPage] = useState(1)
  const [pages, setPages] = useState(0)
  const [links, setLinks] = useState([])
  const [search, setSearch] = useState('')
  const [pageLoading, setPageLoading] = useState(false)
  const [buttonLoading, setButtonLoading] = useState(false)

  useEffect(() => {
    getPage(1)
  }, [])

  useEffect(() => {
    let p = 0
    if(resultsCount && pageCount){
      p = Math.ceil(resultsCount / pageCount)
    }
    setPages(p)
  }, [resultsCount, pageCount])

  useEffect(() => {
    if(pages){
      let l = []
      for(let i = 0;i<pages;i++){
        l.push((
        <li className={i+1 == curPage ? 'active' : ''}>
          <a style={{cursor:'pointer'}} onClick={() => { getPage(i+1) }}>{i+1}</a>
        </li>
        ))
      }
      setLinks(l)
    }
  }, [pages, curPage])

  function getPage(np){
    setPageLoading(true)
    setCurPage(np)
    let new_orgs = []
    jfetch.get('/organizations/search', {page:np, textfilter:search}).then((resp) => {
      setResultsCount(resp.result_count)
      setPageCount(resp.page_count)
      resp.organizations.data.forEach(el => {
        new_orgs.push(el.attributes)
      });
      setOrgs(new_orgs)
      setPageLoading(false)
      setButtonLoading(false)
    })
  }

  return (
    <>
      <div className="row" style={{paddingBottom:'50px', paddingTop:'25px'}}>
        <div className="col-lg-3">
          <input 
            onChange={(e) => {
              setSearch(e.target.value)
            }}
            onKeyDown={(e) => {
              if(e.keyCode == 13){
                getPage(1)
              }
            }}
            type="text" 
            className="form-control" 
            placeholder="Enter Search.."
          />
        </div>
        <div className="col-lg-2">
          <Button 
            color="primary" 
            onClick={() => {
              setButtonLoading(true)
              getPage(1)
            }}
            loading={buttonLoading}
            >
            Search
          </Button>
        </div>
        <div className="col-lg-7">
        </div>
      </div>   
      <div className="row" style={{paddingBottom:'25px'}}>
        <div className="col-lg-12">
          <table className="table table-hover">
            <thead>
              <tr>
                <th>Name</th>
                <th>Permission Group</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {orgs.map((org) => {
                return (
                  <tr key={org.id}>
                    <td><a href={org.company_url}>{org.title}</a></td>
                    <td>{org.membership_type}</td>
                    <td>{ org.active ? <span className="text-success">Active</span> : <span className="text-danger">Inactive</span>}</td>
                  </tr>  
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <nav aria-label="Page navigation">
            <ul className="pagination" style={{float:'left'}}>
              <li>
                <a href="#" aria-label="Previous">
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
                {links}
              <li>
                <a href="#" aria-label="Next">
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </>
  )
}

interface UProps{

}

function UsersTable(props:UProps){
  const [users, setUsers] = useState([])
  const [resultsCount, setResultsCount] = useState(0)
  const [pageCount, setPageCount] = useState(0)
  const [curPage, setCurPage] = useState(1)
  const [pages, setPages] = useState(0)
  const [links, setLinks] = useState([])
  const [search, setSearch] = useState('')
  const [pageLoading, setPageLoading] = useState(false)
  const [buttonLoading, setButtonLoading] = useState(false)

  useEffect(() => {
    getPage(1)
  }, [])

  useEffect(() => {
    let p = 0
    if(resultsCount && pageCount){
      p = Math.ceil(resultsCount / pageCount)
    }
    setPages(p)
  }, [resultsCount, pageCount])

  useEffect(() => {
    if(pages){
      let l = []
      for(let i = 0;i<pages;i++){
        l.push((
        <li className={i+1 == curPage ? 'active' : ''}>
          <a style={{cursor:'pointer'}} onClick={() => { getPage(i+1) }}>{i+1}</a>
        </li>
        ))
      }
      setLinks(l)
    }
  }, [pages, curPage])

  function getPage(np){
    setPageLoading(true)
    setCurPage(np)
    let new_users = []
    jfetch.get('/employees/search', {page:np, textfilter:search}).then((resp) => {
      setResultsCount(resp.result_count)
      setPageCount(resp.page_count)
      resp.users.data.forEach(el => {
        let new_u = el.attributes
        new_u.login_link = el.links.login_link
        new_users.push(new_u)
      });
      setUsers(new_users)
      setPageLoading(false)
      setButtonLoading(false)
    })
  }  
  return (
    <>
      <div className="row" style={{paddingBottom:'50px', paddingTop:'25px'}}>
        <div className="col-lg-3">
          <input 
            onChange={(e) => {
              setSearch(e.target.value)
            }}
            onKeyDown={(e) => {
              if(e.keyCode == 13){
                getPage(1)
              }
            }}
            type="text" 
            className="form-control" 
            placeholder="Enter Search.."
          />
        </div>
        <div className="col-lg-2">
          <Button 
            color="primary" 
            onClick={() => {
              setButtonLoading(true)
              getPage(1)
            }}
            loading={buttonLoading}
            >
            Search
          </Button>
        </div>
        <div className="col-lg-7">
        </div>
      </div>   
      <div className="row" style={{paddingBottom:'25px'}}>
        <div className="col-lg-12">
          {/* <div className="table-responsive"> */}
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Login</th>
                  <th>Email</th>
                  <th>Organization</th>
                  <th>Status</th>
                  <th><span style={{paddingLeft:'15px'}}>Roles</span></th>
                </tr>
              </thead>
              <tbody>
                {users.map((user) => {
                  return (
                    <tr key={user.id}>
                      <td>                        
                        <a href={`/employees/${user.id}`}>
                          {user.name}
                        </a>
                      </td>
                      <td>
                        { (user.active && user.invitation_accepted_at != null) ? (
                          <a href={user.login_link}>
                            <i className="fa fa-external-link"/>
                          </a>                      
                        ) : (
                          <a style={{color:'grey', cursor:'not-allowed'}} title="user has not accepted invite or is inactive">  
                            <i className="fa fa-ban" aria-hidden="true"/>
                          </a>
                        )}
                      </td>
                      <td>{user.email}</td>
                      <td>{user.organization}</td>
                      <td>{ user.active ? <span className="text-success">Active</span> : <span className="text-danger">Inactive</span>}</td>
                      <td>
                        <div className="roles-div">
                          { user.is_owner && (
                            <div className="role-span" style={{backgroundColor:'#b78c20'}}>owner</div>
                          )}
                          {user.roles.map((role, i) => {
                            return <div key={`role-${i}`} className="role-span">{role}</div>
                          })}
                        </div>
                      </td>
                    </tr>  
                  )
                })}
              </tbody>
            </table>
          {/* </div> */}
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <nav aria-label="Page navigation">
            <ul className="pagination" style={{float:'left'}}>
              <li>
                <a href="#" aria-label="Previous">
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
                {links}
              <li>
                <a href="#" aria-label="Next">
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </>
  )
}

export default OrganizationIndex;



// WEBPACK FOOTER //
// ./app/javascript/components/pages/OrganizationIndex.tsx